module.exports = __webpack_public_path__ + "img/IMG-20191123-WA0022.6c60b6cc.jpg";